var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 21.6h2.4c.2 0 .2 0 .3-.2V15c0-.2-.1-.3-.3-.3H18c-.2 0-.4.1-.4.3v6.4c0 .1.2.3.4.3zm5.9 0h2.3c.2 0 .2-.3.3-.5v-10c0-.2-.1-.3-.3-.3H24c-.2 0-.3.1-.3.3v10.1c0 .2.1.3.3.3zm-11.8 0h2.3c.2 0 .2-.3.3-.5V10c0-.2-.1-.4-.3-.4H12c-.2 0-.3.2-.3.4v11c0 .2 0 .4.3.4zm-5.8 0h2.3c.2 0 .3-.4.3-.6V2.5c0-.3-.1-.5-.3-.5H6.3c-.2 0-.3.3-.3.5V21c0 .3.1.5.3.5zm23.1 2.9H2.8V.3c0-.1-.1-.3-.3-.3H.3L0 .3V27l.3.3h29.2l.3-.3v-2.2c0-.2-.2-.3-.4-.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.ebf6f4a3.svg";
export { ForwardRef as ReactComponent };